import "../registerLogin/RegisterlLogin.css";

interface IButtonLoginRegister {
  mode: string;
  actions: {
    handleSwitchForm: () => void;
  }
}

export function ButtonLoginRegister({ mode, actions }: IButtonLoginRegister) {
  return (
    <div id="div-login-register" className="flex justify-end">

      <button
        style={{ backgroundColor: "#E09F3E", color: "white" }}
        type="button"
        id="btn-login-and-register-card"
        className="rounded-xl w-28 h-auto py-2 px-1"
        onClick={() => {
          actions.handleSwitchForm();
        }}>
        {mode}
      </button>
    </div>
  )
}